<template>
    <div class="main-content">
        <!-- TOASTS DE NOTIFICAÇÃO -->
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0 flex-nowrap text-nowrap align-items-center"
                    style="overflow-x: auto; scrollbar-width: none;">
                    <li class="breadcrumb-item">
                        <router-link class="nav-link d-inline" to="/">Início</router-link>
                    </li>
                    <li class="breadcrumb-item active text-dark small" aria-current="page">
                        Páginas de Captura
                    </li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold">Páginas de Captura</h4>
                    <span class="text-muted fs-7">Exibindo {{ pages.length }} de {{ totalItems }}</span>
                </div>

                <div class="d-flex gap-2 align-items-center">
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="d-flex align-items-center me-2 pe-3 border-end">
                            <button class="btn btn-pmg-danger btn-sm px-3"
                                @click="confirmDelete(selectedIds.length, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{ selectedIds.length }})
                            </button>
                        </div>
                    </transition>

                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <router-link to="/new-page-lead" class="btn btn-pmg-primary text-decoration-none">
                        <i class="bi bi-plus-lg me-1"></i> Nova Página
                    </router-link>
                </div>
            </div>

            <!-- Filtros -->
            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3">
                        <div class="col-md-10">
                            <input v-model="filter.title" type="text" class="form-control form-control-pmg"
                                placeholder="Filtrar pelo título da página...">
                        </div>
                        <div class="col-md-2 d-flex">
                            <button class="btn btn-dark w-100 btn-pmg-dark fw-bold" @click="applyFilter">
                                <i class="bi bi-search me-1"></i> Filtrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tabela de Listagem -->
            <div class="table-responsive">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 35%">Título da Página</th>
                            <th style="width: 30%">Link Público (Slug)</th>
                            <th style="width: 15%">Status</th>
                            <th style="width: 15%" class="text-end">Ações</th>
                        </tr>
                    </thead>

                    <tbody v-if="pages.length > 0">
                        <tr v-for="item in pages" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td>
                                <input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>
                            <td>
                                <div class="fw-bold text-dark">{{ item.title }}</div>
                                <div class="text-muted small text-truncate-custom" style="max-width: 300px;">
                                    {{ item.subtitle || 'Sem subtítulo' }}
                                </div>
                            </td>
                            <td>
                                <a :href="getPublicUrl(item.slug)" target="_blank"
                                    class="text-decoration-none text-primary small">
                                    <i class="bi bi-box-arrow-up-right me-1"></i> /p/{{ item.slug }}
                                </a>
                            </td>
                            <td>
                                <span class="badge rounded-pill"
                                    :class="item.is_active ? 'text-bg-success' : 'text-bg-secondary'">
                                    {{ item.is_active ? 'Ativa' : 'Inativa' }}
                                </span>
                            </td>
                            <td class="text-end align-middle">
                                <div class="dropdown">
                                    <button
                                        class="btn btn-action-dropdown rounded-3 border bg-white shadow-sm px-2 py-1"
                                        type="button" data-bs-toggle="dropdown" data-bs-boundary="body"
                                        aria-expanded="false">
                                        <i class="bi bi-three-dots-vertical text-dark fs-6"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end border-0 shadow-lg p-2 rounded-4">
                                        <li>
    <router-link class="dropdown-item fw-bold text-primary bg-primary-subtle py-2 d-flex align-items-center" :to="{ name: 'lead-response', params: { id: item.id } }">
        <i class="bi bi-list-check me-2 fs-6"></i>Ver leads
    </router-link>
</li>
<li><hr class="dropdown-divider opacity-10 my-1"></li>
                                        <li>
                                            <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2 text-secondary fw-medium"
                                                href="#" @click.prevent="openQrModal(item)">
                                                <i class="bi bi-qr-code fs-6"></i> Ver QR Code Puro
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2 text-secondary fw-medium"
                                                href="#" @click.prevent="openUtmModal(item)">
                                                <i class="bi bi-sliders fs-6"></i> Gerar Link & QR com UTM
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2 text-secondary fw-medium"
                                                href="#" @click.prevent="viewStatistics(item.id)">
                                                <i class="bi bi-bar-chart-line fs-6"></i> Ver Estatísticas
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2 text-secondary fw-medium"
                                                href="#" @click.prevent="editPage(item)">
                                                <i class="bi bi-pencil fs-6"></i> Editar
                                            </a>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider my-1 border-light">
                                        </li>
                                        <li>
                                            <a class="dropdown-item rounded-2 py-2 d-flex align-items-center gap-2 text-danger fw-medium"
                                                href="#" @click.prevent="confirmDeletePage(item.id)">
                                                <i class="bi bi-trash fs-6"></i> Excluir
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="5" class="text-center py-5 text-muted">
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <i class="bi bi-window-stack fs-1 mb-2 text-secondary opacity-50"></i>
                                    <span class="fw-medium">Nenhuma página de captura encontrada.</span>
                                    <span class="small mt-1" v-if="filter.title">Tente limpar os filtros de busca.</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Botão Carregar Mais -->
            <div class="text-center mt-4" v-if="hasMore">
                <button
                    class="btn btn-pmg-light px-5 btn-sm fw-bold d-inline-flex align-items-center justify-content-center"
                    @click="loadMore" :disabled="loading" style="min-width: 220px;">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                    <span>{{ loading ? 'Carregando dados...' : 'Carregar mais itens' }}</span>
                </button>
            </div>
        </div>

        <!-- Modal Confirmação de Exclusão -->
        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3">
                            <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">
                            {{ isBulkDelete
                                ? `Excluir ${selectedIds.length} páginas selecionadas? Todos os leads atrelados podem ser perdidos.`
                                : `Excluir a página "${itemToDelete?.title}"? Nota: Todos os leads atrelados podem ser perdidos.` }}
                        </p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal QR Code Puro -->
        <div class="modal fade" id="qrCodeModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-4">
                    <div class="modal-header border-0 pb-0 justify-content-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body pt-0">
                        <div class="mb-2" style="color: #561569;">
                            <i class="bi bi-qr-code-scan fs-1"></i>
                        </div>
                        <h5 class="fw-bold text-dark mb-1">QR Code da Página</h5>
                        <p class="text-muted small text-truncate mb-3">{{ qrPageTitle }}</p>

                        <div class="bg-light p-3 rounded-4 d-inline-block shadow-sm mb-3 border">
                            <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="QR Code da Página" class="img-fluid rounded"
                                style="width: 180px; height: 180px;" />
                        </div>

                        <div class="d-grid gap-2">
                            <button class="btn btn-pmg-light btn-sm fw-medium py-2" @click="copyLinkFromModal">
                                <i class="bi bi-clipboard me-1"></i> Copiar Link Público
                            </button>
                            <button class="btn btn-pmg-primary btn-sm fw-medium py-2" @click="downloadQrCode">
                                <i class="bi bi-download me-1"></i> Baixar QR Code (PNG)
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Construtor de Link & QR Code com UTM -->
        <div class="modal fade" id="utmModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0 shadow-lg rounded-4 p-4">
                    <div class="modal-header border-0 pb-0 mb-3">
                        <div>
                            <h5 class="fw-bold text-dark mb-1">Construtor de Link e QR Code com UTM</h5>
                            <p class="text-muted small mb-0">{{ utmPageTitle }}</p>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    
                    <div class="modal-body p-0">
                        <div class="row g-0">
                            
                            <!-- COLUNA 1: Histórico de Links (Esquerda) -->
                            <div class="col-lg-3 border-end pe-lg-3 mb-4 mb-lg-0">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h6 class="fw-bold text-dark m-0 small text-uppercase">
                                        <i class="bi bi-clock-history text-primary me-1"></i> Links Salvos
                                    </h6>
                                    <button class="btn btn-sm btn-pmg-light py-0 px-2 fw-bold text-primary" @click="resetUtmForm" title="Criar novo link">
                                        <i class="bi bi-plus-lg"></i> Novo
                                    </button>
                                </div>
                                
                                <div v-if="savedUtmLinks && savedUtmLinks.length > 0" class="list-group list-group-flush overflow-auto pe-1" style="max-height: 420px;">
                                    <div v-for="link in savedUtmLinks" :key="link.id" 
                                         class="list-group-item list-group-item-action border rounded-3 mb-2 p-2 shadow-sm"
                                         :class="{'border-primary bg-primary-subtle': utmForm.id === link.id}">
                                        
                                        <div class="d-flex justify-content-between align-items-start mb-1">
                                            <!-- Título clicável para carregar os dados -->
                                            <div class="text-truncate fw-bold text-dark small" :title="link.name" style="max-width: 140px; cursor: pointer;" @click="loadSavedUtm(link)">
                                                {{ link.name || 'Sem nome' }}
                                            </div>
                                            <!-- Ações Rápidas -->
                                            <div class="d-flex gap-1">
                                                <button class="btn btn-sm btn-link text-success p-0" @click="copyToClipboard(link.full_url)" title="Copiar URL Final">
                                                    <i class="bi bi-link-45deg fs-5"></i>
                                                </button>
                                                <button class="btn btn-sm btn-link text-danger p-0 ms-1" @click="deleteUtmLink(link.id)" title="Excluir Link">
                                                    <i class="bi bi-trash fs-6"></i>
                                                </button>
                                            </div>
                                        </div>
                                        
                                        <!-- Badges com os parâmetros clicáveis -->
                                        <div class="text-muted" style="font-size: 0.7rem; cursor: pointer;" @click="loadSavedUtm(link)">
                                            <span class="badge bg-white text-secondary border me-1">{{ link.utm_source || 'N/A' }}</span>
                                            <span class="badge bg-white text-secondary border">{{ link.utm_campaign || 'N/A' }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Estado Vazio -->
                                <div v-else class="text-center p-3 border rounded-3 bg-light">
                                    <p class="text-muted small mb-0"><i class="bi bi-info-circle me-1"></i> Nenhum link salvo ainda.</p>
                                </div>
                            </div>

                            <!-- COLUNA 2: Inputs de Edição/Criação (Meio) -->
                            <div class="col-lg-5 border-end px-lg-4 mb-4 mb-lg-0">
                                <h6 class="fw-bold text-dark mb-3 small text-uppercase">
                                    <i class="bi bi-sliders text-primary me-1"></i> Parâmetros
                                </h6>
                                
                                <div class="mb-3">
                                    <label class="form-label small fw-bold text-secondary">Nome de Identificação (Opcional)</label>
                                    <input v-model="utmForm.name" type="text" class="form-control form-control-pmg bg-light border-primary-subtle" placeholder="Ex: Bio do Instagram, Campanha Face">
                                </div>
                                
                                <div class="mb-3">
                                    <label class="form-label small fw-bold text-secondary">UTM Source (Origem)</label>
                                    <input v-model="utmForm.utm_source" type="text" class="form-control form-control-pmg" placeholder="Ex: instagram">
                                </div>
                                
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label class="form-label small fw-bold text-secondary">UTM Medium (Meio)</label>
                                        <input v-model="utmForm.utm_medium" type="text" class="form-control form-control-pmg" placeholder="Ex: social">
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="form-label small fw-bold text-secondary">UTM Campaign</label>
                                        <input v-model="utmForm.utm_campaign" type="text" class="form-control form-control-pmg" placeholder="Ex: black_friday">
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label class="form-label small fw-bold text-secondary">UTM Term</label>
                                        <input v-model="utmForm.utm_term" type="text" class="form-control form-control-pmg" placeholder="Ex: tenis_corrida">
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="form-label small fw-bold text-secondary">UTM Content</label>
                                        <input v-model="utmForm.utm_content" type="text" class="form-control form-control-pmg" placeholder="Ex: banner_azul">
                                    </div>
                                </div>

                                <!-- Preview & Save Button -->
                                <div class="mb-0 mt-3 pt-3 border-top">
                                    <label class="form-label small fw-bold text-secondary">Link Final Gerado</label>
                                   <div class="input-group">
                                        <input type="text" class="form-control form-control-pmg bg-light text-muted small" :value="generatedUtmUrl" readonly>
                                        
                                        <button class="btn btn-pmg-primary" type="button" @click="copyGeneratedUtmUrl" title="Copiar Link">
                                            <i class="bi bi-clipboard"></i>
                                        </button>
                                        
                                        <!-- Botão Dinâmico: Salvar / Atualizar -->
                                        <button :class="utmForm.id ? 'btn-warning' : 'btn-success'" 
                                                class="btn fw-bold px-3 border-0 text-white" 
                                                type="button" 
                                                @click="saveCurrentUtm" 
                                                :disabled="loadingUtmSave">
                                            <template v-if="loadingUtmSave">
                                                <span class="spinner-border spinner-border-sm"></span>
                                            </template>
                                            <template v-else>
                                                <i class="bi me-1" :class="utmForm.id ? 'bi-arrow-repeat' : 'bi-save2'"></i>
                                                {{ utmForm.id ? 'ATUALIZAR' : 'SALVAR' }}
                                            </template>
                                        </button>

                                        <!-- Botão Cancelar Edição (Só aparece se estiver editando) -->
                                        <button v-if="utmForm.id" 
                                                class="btn btn-danger fw-bold px-3 border-0" 
                                                type="button" 
                                                @click="resetUtmForm" 
                                                title="Cancelar Edição">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- COLUNA 3: QR Code (Direita) -->
                            <div class="col-lg-4 text-center ps-lg-4">
                                <div class="mb-2" style="color: #561569;">
                                    <i class="bi bi-qr-code-scan fs-2"></i>
                                </div>
                                <h6 class="fw-bold text-dark mb-1">QR Code Ativo</h6>
                                <p class="text-muted small mb-3">Atualiza em tempo real</p>

                                <div class="bg-light p-3 rounded-4 d-inline-block shadow-sm mb-3 border">
                                    <img v-if="generatedQrCodeUrl" :src="generatedQrCodeUrl" alt="QR Code com UTM" class="img-fluid rounded"
                                        style="width: 170px; height: 170px;" />
                                </div>

                                <div class="d-grid gap-2 px-xl-3">
                                    <button class="btn btn-pmg-primary btn-sm fw-medium py-2" @click="downloadUtmQrCode">
                                        <i class="bi bi-download me-1"></i> Baixar QR Code (PNG)
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="modal fade" id="confirmDeletePageModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-4">
                    <div class="modal-body p-0">
                        <h4 class="fw-bold mb-3">Tem certeza?</h4>
                        <p class="text-muted mb-4">Excluir "{{ pageTitleToDelete }}"? Nota: Todos os leads atrelados podem ser perdidos.</p>
                        
                        <div class="d-flex gap-3 justify-content-center">
                            <button class="btn btn-outline-secondary px-4 rounded-3" data-bs-dismiss="modal">Cancelar</button>
                            <button class="btn btn-danger px-4 rounded-3" @click="executeDeletePage">Confirmar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import api from '@/services/api';

export default {
    data() {
        return {
            pages: [],
            alerts: [],
            selectedIds: [],
            filter: { title: '' },

            // Variáveis de Paginação
            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            loading: false,
            hasMore: false,
            showFilter: false,

            // Variáveis de Exclusão
            itemToDelete: null,
            isBulkDelete: false,
            qrCodeUrl: '',
            qrPageTitle: '',
            activeSlug: '',

            // Variáveis do Construtor UTM
            utmPageTitle: '',
            utmForm: {
                id: null,
                name: '',
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_term: '',
                utm_content: ''
            },
            savedUtmLinks: [],
            pageToDeleteId: null,
            pageTitleToDelete: '',
        }
    },
    computed: {
        isAllSelected() {
            return this.pages.length > 0 && this.pages.every(i => this.selectedIds.includes(i.id));
        },
        generatedUtmUrl() {
            if (!this.activeSlug) return '';
            const baseUrl = this.getPublicUrl(this.activeSlug);
            const params = new URLSearchParams();

            Object.keys(this.utmForm).forEach(key => {
                if (this.utmForm[key]) {
                    params.append(key, this.utmForm[key]);
                }
            });

            const queryString = params.toString();
            return queryString ? `${baseUrl}?${queryString}` : baseUrl;
        },
        generatedQrCodeUrl() {
            if (!this.generatedUtmUrl) return '';
            return `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(this.generatedUtmUrl)}`;
        }
    },
    mounted() {
        this.fetchPages();
    },
    methods: {
        async fetchPages(page = 1, append = false) {
            this.loading = true;
            try {
                const params = {
                    page: page,
                    search: this.filter.title
                };

                const response = await api.get('/capture-pages', { params });
                const payload = response.data;
                const items = Array.isArray(payload) ? payload : (payload.data || []);
                const paginationData = payload.meta || payload;
                const { current_page, last_page, total } = paginationData;

                if (append) {
                    this.pages = [...this.pages, ...items];
                } else {
                    this.pages = items;
                }

                this.currentPage = current_page;
                this.lastPage = last_page;
                this.totalItems = total;
                this.hasMore = this.currentPage < this.lastPage;

            } catch (error) {
                this.showAlert('Falha ao comunicar com o servidor.', 'error');
                console.error("Erro na API:", error);
            } finally {
                this.loading = false;
            }
        },

        loadMore() {
            if (this.hasMore && !this.loading) {
                this.fetchPages(this.currentPage + 1, true);
            }
        },

        applyFilter() {
            this.showFilter = false;
            this.selectedIds = [];
            this.fetchPages(1, false);
        },

        getPublicUrl(slug) {
            const baseUrl = process.env.VUE_APP_DONATION || window.location.origin;
            return `${baseUrl}/p/${slug}`;
        },

        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';
            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });
            setTimeout(() => this.removeAlert(id), type === 'error' ? 6000 : 4000);
        },

        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },

        toggleAll(e) {
            if (e.target.checked) this.selectedIds = this.pages.map(c => c.id);
            else this.selectedIds = [];
        },

        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteModal'));
            modal.show();
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) {
                    await api.post('/capture-pages/bulk-delete', { ids: this.selectedIds });
                    this.pages = this.pages.filter(p => !this.selectedIds.includes(p.id));
                    this.totalItems -= this.selectedIds.length;
                    this.showAlert(`${this.selectedIds.length} páginas excluídas.`);
                    this.selectedIds = [];
                } else {
                    await api.delete(`/capture-pages/${this.itemToDelete.id}`);
                    this.pages = this.pages.filter(p => p.id !== this.itemToDelete.id);
                    this.totalItems -= 1;
                    this.showAlert(`Página "${this.itemToDelete.title}" removida.`);
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Erro ao comunicar com o servidor.';
                this.showAlert(errorMessage, 'error');
            } finally {
                const modalElement = document.getElementById('confirmDeleteModal');
                if (modalElement) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) modalInstance.hide();
                }
            }
        },

        copyLink(page) {
            const url = this.getPublicUrl(page.slug);
            navigator.clipboard.writeText(url)
                .then(() => {
                    this.showAlert('Link copiado para a área de transferência!');
                })
                .catch(err => {
                    console.error('Erro ao copiar link: ', err);
                    this.showAlert('Não foi possível copiar o link.', 'error');
                });
        },

        editPage(page) {
            this.$router.push(`/edit-page-lead/${page.id}`);
        },

        async deletePage(id) {
            if (!confirm('Tem certeza que deseja excluir esta página?')) return;

            try {
                await api.delete(`/capture-pages/${id}`);
                this.showAlert('Página excluída com sucesso!');
                this.fetchPages();
            } catch (error) {
                console.error(error);
                this.showAlert('Erro ao excluir a página.', 'error');
            }
        },

        openQrModal(page) {
            this.qrPageTitle = page.title;
            this.activeSlug = page.slug;

            const url = this.getPublicUrl(page.slug);
            this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(url)}`;

            const modalElement = document.getElementById('qrCodeModal');
            if (modalElement) {
                const modal = new window.bootstrap.Modal(modalElement);
                modal.show();
            }
        },

        openUtmModal(page) {
            this.selectedPage = page;
            this.utmPageTitle = page.title;
            this.activeSlug = page.slug;
            this.utmForm = {
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_term: '',
                utm_content: ''
            };

            const modalElement = document.getElementById('utmModal');
            if (modalElement) {
                const modal = new window.bootstrap.Modal(modalElement);
                this.fetchSavedUtmLinks();
                modal.show();
            }
        },
        async fetchSavedUtmLinks() {
            try {
                const response = await api.get(`/capture-pages/${this.selectedPage.id}/utm-links`);
                // Garante que pega o array correto dependendo de como a sua API retorna (com ou sem 'data' wrapper)
                this.savedUtmLinks = response.data.data || response.data;
            } catch (e) {
                console.error("Erro ao buscar links UTM salvos:", e);
            }
        },

        // 2. Joga os dados do link salvo de volta para os inputs de edição
        loadSavedUtm(link) {
            this.utmForm = {
                id: link.id,
                name: link.name || '',
                utm_source: link.utm_source || '',
                utm_medium: link.utm_medium || '',
                utm_campaign: link.utm_campaign || '',
                utm_term: link.utm_term || '',
                utm_content: link.utm_content || ''
            };
        },

        // 3. Exclui um link da lista
        async deleteUtmLink(linkId) {
            if (!confirm('Tem certeza que deseja excluir este link salvo?')) return;

            try {
                await api.delete(`/capture-pages/${linkId}/utm-links`);
                this.showAlert('Link UTM excluído com sucesso!');
                
                // Atualiza a lista na tela instantaneamente
                this.fetchSavedUtmLinks(); 
                
                // Se o usuário excluiu o link que ele estava editando no momento, limpa a tela
                if (this.utmForm.id === linkId) {
                    this.resetUtmForm();
                }
            } catch (e) {
                console.error("Erro ao excluir link UTM:", e);
                this.showAlert('Erro ao excluir link UTM.', 'error');
            }
        },

        // 4. Copia a URL final diretamente da tabela de histórico
        async copyToClipboard(text) {
            try {
                await navigator.clipboard.writeText(text);
                this.showAlert('URL copiada para a área de transferência!');
            } catch (err) {
                console.error('Falha ao copiar:', err);
                
                // Fallback para navegadores mais antigos
                const tempInput = document.createElement("input");
                tempInput.value = text;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand("copy");
                document.body.removeChild(tempInput);
                this.showAlert('URL copiada para a área de transferência!');
            }
        },

        async saveCurrentUtm() {
            this.loadingUtmSave = true;
            try {
                const payload = {
                    ...this.utmForm,
                    full_url: this.generatedUtmUrl // Computed property que monta a URL completa
                };
                await api.post(`/capture-pages/${this.selectedPage.id}/utm-links`, payload);
                this.showAlert('Link UTM salvo com sucesso!');
                this.fetchSavedUtmLinks();
            } catch (e) {
                this.showAlert('Erro ao salvar Link UTM.', 'error');
            } finally {
                this.loadingUtmSave = false;
            }
        },

        resetUtmForm() {
            this.utmForm = { id: null, name: '', utm_source: '', utm_medium: '', utm_campaign: '', utm_term: '', utm_content: '' };
        },

        copyGeneratedUtmUrl() {
            navigator.clipboard.writeText(this.generatedUtmUrl)
                .then(() => {
                    this.showAlert('Link com UTM copiado para a área de transferência!');
                })
                .catch(() => {
                    this.showAlert('Erro ao copiar link.', 'error');
                });
        },

        copyLinkFromModal() {
            const url = this.getPublicUrl(this.activeSlug);
            navigator.clipboard.writeText(url)
                .then(() => {
                    this.showAlert('Link copiado para a área de transferência!');
                })
                .catch(() => {
                    this.showAlert('Erro ao copiar link.', 'error');
                });
        },

        async downloadQrCode() {
            try {
                const response = await fetch(this.qrCodeUrl);
                const blob = await response.blob();
                const link = document.createElement('a');

                link.href = window.URL.createObjectURL(blob);
                const safeSlug = this.activeSlug ? this.activeSlug.replace(/[^a-z0-9]/gi, '_').toLowerCase() : 'qrcode';
                link.download = `qrcode-${safeSlug}.png`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
                this.showAlert('QR Code baixado com sucesso!');
            } catch (error) {
                console.error('Erro ao baixar QR Code:', error);
                this.showAlert('Não foi possível baixar o QR Code.', 'error');
            }
        },

        async downloadUtmQrCode() {
            try {
                const response = await fetch(this.generatedQrCodeUrl);
                const blob = await response.blob();
                const link = document.createElement('a');

                link.href = window.URL.createObjectURL(blob);
                const safeSlug = this.activeSlug ? this.activeSlug.replace(/[^a-z0-9]/gi, '_').toLowerCase() : 'qrcode';
                const sourceSuffix = this.utmForm.utm_source ? `-${this.utmForm.utm_source.replace(/[^a-z0-9]/gi, '_').toLowerCase()}` : '';
                link.download = `qrcode-${safeSlug}${sourceSuffix}.png`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
                this.showAlert('QR Code com UTM baixado com sucesso!');
            } catch (error) {
                console.error('Erro ao baixar QR Code com UTM:', error);
                this.showAlert('Não foi possível baixar o QR Code.', 'error');
            }
        },
        viewStatistics(pageId) {
            this.$router.push({ name: 'page-statistics', params: { id: pageId } });
       },
       confirmDeletePage(page) {
            this.pageToDeleteId = page.id;
            // Ajuste 'page.title' ou 'page.name' conforme a propriedade real do seu banco
            this.pageTitleToDelete = page.title || 'esta página'; 
            
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeletePageModal'));
            modal.show();
        },
       async executeDeletePage() {
            if (!this.pageToDeleteId) return;

            try {
                await api.delete(`/capture-pages/${this.pageToDeleteId}`);
                this.showAlert('Página excluída com sucesso!');
                this.fetchPages(); // Atualiza a listagem
            } catch (error) {
                console.error(error);
                this.showAlert('Erro ao excluir a página.', 'error');
            } finally {
                // Fecha o modal e limpa as variáveis de controle
                const modalEl = document.getElementById('confirmDeletePageModal');
                if (modalEl) {
                    const modal = window.bootstrap.Modal.getInstance(modalEl);
                    if (modal) modal.hide();
                }
                
                this.pageToDeleteId = null;
                this.pageTitleToDelete = '';
            }
        }
    }
}
</script>

<style scoped>
/* ESTILOS DE ALERTA (TOASTS) */
.toast {
    min-width: 300px;
    border-radius: 12px;
    background-color: white !important;
}

.bg-success-subtle {
    background-color: #ecfdf5 !important;
    color: #059669 !important;
    border-left: 5px solid #059669 !important;
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #991b1b !important;
    border-left: 5px solid #ef4444 !important;
}

/* LAYOUT PMG */
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-primary:hover {
    background: #451054;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

/* Tabela */
.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.text-truncate-custom {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Transições */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

.breadcrumb::-webkit-scrollbar {
    display: none;
}

.breadcrumb-item .nav-link {
    display: inline;
    padding: 0;
}

td.actions-cell {
    position: relative;
}

td.actions-cell,
.table-responsive {
    overflow: visible !important;
}

.dropdown-menu {
    z-index: 1050 !important;
}
</style>